import React from 'react'
import { PercentageText } from '../../../Global'

export const TableDataCellWinRate = ({ dataValue }: { dataValue?: number }) => {
  return <PercentageText value={Number(dataValue)} />
}
